<div class="info-page">
  <header class="info-hero">
    <p class="info-kicker">Money back</p>
    <h1 class="info-heading">Refund Policy</h1>
    <p class="info-sub">Refunds are rare. Please read this before you buy a seat.</p>
  </header>

  <div class="info-grid info-grid--two">
    <article class="info-card">
      <p class="info-updated">Last updated: September 20, 2025</p>
      <h2 class="info-block-title"><span class="info-icon info-icon--gold">1</span> Overview</h2>
      <p>At Lootlucky.com, we strive to ensure your satisfaction with every purchase. However, refunds are granted only in exceptional circumstances. Please review this policy carefully before making a purchase.</p>
    </article>

    <article class="info-card info-card--alert">
      <h2 class="info-block-title"><span class="info-icon info-icon--wine">2</span> Non-Refundable Items</h2>
      <p>Product reviews purchased through our e-commerce site are non-refundable. We ensure that all products are accurately described, inspected, and delivered as promised.</p>
      <p>Refunds are not offered for the following reasons:</p>
      <ul>
        <li>Change of mind or buyer's remorse.</li>
        <li>Dissatisfaction with a review or reviewer.</li>
      </ul>
    </article>

    <article class="info-card">
      <h2 class="info-block-title"><span class="info-icon info-icon--teal">3</span> Eligible Refunds</h2>
      <p>Refunds may be considered only under the following rare circumstances:</p>
      <ol>
        <li><strong>Non-Delivery:</strong> If a "free win order" has not been delivered within the specified timeframe and is confirmed lost by the carrier.</li>
        <li><strong>Defective or Incorrect Item:</strong> If an item received is significantly different from the description or is defective upon arrival.</li>
      </ol>
    </article>

    <article class="info-card">
      <h2 class="info-block-title"><span class="info-icon info-icon--purple">4</span> Request Process</h2>
      <p>To request a refund, you must:</p>
      <ol>
        <li>Contact customer support team within 7 days of not receiving your order.</li>
        <li>Provide order number, a detailed explanation of the issue, and supporting evidence (e.g., photos of defective items or proof of non-delivery).</li>
        <li>Await review and approval. The company reserves the right to deny any refund request that does not meet strict eligibility criteria.</li>
      </ol>
    </article>

    <article class="info-card">
      <h2 class="info-block-title"><span class="info-icon info-icon--coral">5</span> Approved Refunds</h2>
      <p>If a refund is approved:</p>
      <ul>
        <li>Refunds will be processed to the original payment method within 10 business days after a decision has been made if eligible.</li>
        <li>Shipping costs are non-refundable, and return shipping costs (if applicable) are the responsibility of the customer.</li>
        <li>A restocking fee of up to 20% may apply to cover handling and processing.</li>
      </ul>
    </article>

    <article class="info-card">
      <h2 class="info-block-title"><span class="info-icon info-icon--olive">6</span> Exchanges</h2>
      <p>Exchanges are not offered unless the item received is defective or incorrect. In such cases, the item will be replaced with an identical or comparable product, subject to availability.</p>
      <p>Questions? <a routerLink="/Contact">Contact us</a></p>
      <a class="info-cta" routerLink="/Contact">Start a request</a>
    </article>
  </div>
</div>
